<script lang="ts">
import { defineComponent, PropType } from "vue";
import KlereoToggle from "@/shared/components/KlereoToggle.vue";
import { PoolDetails } from "@/models/pool-details.model";

export default defineComponent({
  components: { KlereoToggle },
  props: {
    out: Object as PropType<PoolDetails["outs"][number]>,
  },
  emits: ["change"],
});
</script>

<template>
  <div class="flex items-center">
    <div class="text-[10px]">OFF</div>
    <klereo-toggle
      class="mx-1"
      :value="out!.status"
      :on-value="1"
      :off-value="0"
      @change="(value) => $emit('change', value)"
    />
    <div class="text-[10px]">ON</div>
  </div>
</template>
